// src/contracts/getContractAddress.ts
var addresses = {
  BaseRegistrarImplementation: {
    "1": "0xF3e191f3C0Ae33E80994304e04AC49f3517F9B83",
    "5": "0x309625BC92B82AE311AB32823DfdF59d4909E10e",
    "11155111": "0x81bdeD550125bD444cd98c2716CC0A5c94CCe433",
    "8453": "0xf5D28dC8f859C93036B15C558508e010b7297a28"
  },
  DNSRegistrar: {
    "1": "0xFF369d7eA83d2f4552BdDF8f5c5cF67c2AD7Dc85",
    "5": "0x3F4A2eBF63b06481d4ce70FCFDE4B26d4D85CA4F",
    "11155111": "0xD76e72676bB1B2F6fd079d23a707d8495eDbD67b",
    "8453": "0xaAD4A484AA1E810ffebc5152CeB0B87c5dfA25F0"
  },
  ETHRegistrarController: {
    "1": "0x8b4659801644ea0e86015442bEc3d5560cAd85ED",
    "5": "0x0daeBBb0F9fBc6D0dA6bc11D8dC7745e9e76E561",
    "11155111": "0x116EA21C32b47756AEf3ec83B322758De0124864",
    "8453": "0xC9dF8C29336f9d5027187f5e56cc1689A40d54f1"
  },
  Multicall: {
    "1": "0xcA11bde05977b3631167028862bE2a173976CA11",
    "5": "0xcA11bde05977b3631167028862bE2a173976CA11",
    "11155111": "0xcA11bde05977b3631167028862bE2a173976CA11",
    "8453": "0x01096E802a1f6798173f2b876fbc6A8D423D8bdD"
  },
  NameWrapper: {
    "1": "0xaca43897a43886C82b386e09c79169c6cA9EeD64",
    "5": "0xa2f3B78947b3A658f16CCB14fa95f866583a9b9c",
    "11155111": "0x2b4DEeb0e1cC1AB51BA4377BE80fE5E9aDd1daD5",
    "8453": "0x3680ED2E1bb029904CdbFf20C9958e2327E846f4"
  },
  PublicResolver: {
    "1": "0x8C545C7cad38a6D7030EEA7eb187B25CBE8C9494",
    "5": "0x6Bc776b070F90508e9b417ed88b6cD0845c8C0E8",
    "11155111": "0x7c4686a888b1379602e0801Cc9e3cA92CE5001ee",
    "8453": "0x4bEB799b1c0b74C05E664653Bbd5e67aC1A7aa36"
  },
  ENSRegistry: {
    "1": "0xD42d6e8B9D68a7E733C8d4fe2807AEa2C7b5A1FC",
    "5": "0xA96B6bE7dd8B657c088943c140Bae0bf190DF931",
    "11155111": "0x83F191DcF35DE11ba2a3AeAE9C09B027A9b3790f",
    "8453": "0xbf2641ED86B06F0A91a264E9afDd13cdbC0CAD76"
  },
  ReverseRegistrar: {
    "1": "0x762035e47dC0255323Ff964a9F2631f7a36f2903",
    "5": "0x58f9Aa6fac4B10EEE280941B64F0E8BCB07A81C7",
    "11155111": "0x9FA6BF8A9b3706d7110E104175DcEBD4481Cf0f4",
    "8453": "0x8AAE5Fde1eADB2ea54A994587AD1978D0507DfFb"
  },
  UniversalResolver: {
    "1": "0xaAD4A484AA1E810ffebc5152CeB0B87c5dfA25F0",
    "5": "0xeD845B46076654dEEb7EA4fDDD29610790000F7e",
    "11155111": "0x0c270CC9C0B65C2Fcee1478dE048059D8f42Bc86",
    "8453": "0xFd1Eb46EfEAf0134B4d21502930Fb330447f1d79"
  },
  BulkRenewal: {
    "1": "0x0000000000000000000000000000000000000000",
    "5": "0x0000000000000000000000000000000000000000",
    "11155111": "0x0000000000000000000000000000000000000000"
  },
  ERC20: {},
  ERC721: {}
};
var getContractAddress = (networkId) => (contractName) => {
  try {
    return typeof addresses[contractName] === "string" ? addresses[contractName] : addresses[contractName][networkId];
  } catch {
    throw new Error(
      `No address for contract ${contractName} on network ${networkId}`
    );
  }
};
export {
  getContractAddress
};
